import Vue from 'vue'
import App from './App.vue'
import * as Request from './tools/Request.js'
import router from "@/router/router";
import Tool from './tools/Tool.js'
import vConsole from  './tools/vconsole.min.js';
import menu from "@/tools/Menu";
import store from "./store";
Vue.config.productionTip = false

/**
 * css 加载
 */
import "./assets/css/app.css";


import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/element.css';
Vue.use(ElementUI);


//自动加载component
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
const requireComponent = require.context(
    './components',
    true,
    /[A-Za-z0-9-_]+\.(vue|js)$/
)
requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName)
    const componentName = upperFirst(
        camelCase(
            fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
        )
    )
    Vue.component(
        componentName,
        componentConfig.default || componentConfig
    )
})

//开启vconsole
if(process.env.VUE_APP_CONSOLE === 'true'){
    let vconsole = new vConsole();
}

Vue.prototype.request = Request
Vue.prototype.tool = Tool
Vue.prototype.$menu = menu;
Vue.prototype.$animation='animate__animated animate__fadeInUp';
// "animate__fadeInUp"
//确认提示框进行封装
Vue.prototype.$myConfirm = function(callback){
    this.$confirm('确认删除?','提示',{
        confirmButtonText:'确定',
        cancelButtonText:'取消',
        type:'warning'
    }).then(()=>{
    //    回调函数
        callback();
    }).catch(()=>{

    })
}


Vue.prototype.$window = {
    width:window.screen.availWidth, //屏幕可用宽度
    height:window.screen.availHeight, //屏幕可用高度
};

Vue.directive('animateIn', {
  // 指令绑定到元素时触发
  inserted(el, binding) {
    // 配置观察器选项（可自定义）
    const options = {
      root: null, // 监听的根元素（null 表示视口）
      threshold: 0.2, // 元素可见比例达到 10% 时触发
      rootMargin: '0px 0px -10px 0px' // 可视区域边缘扩展（可调整触发时机）
    };

    // 创建观察器
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // if(Object.values(el.classList).includes('charts-img2')){
          //   console.log('动画p2-2');
          // }
          // 元素进入视口：添加动画类
          el.classList.add('animate-enter');
          // 只触发一次动画（如需重复触发可删除此行）
          observer.unobserve(el);
        }
      });
    }, options);

    // 开始观察目标元素
    observer.observe(el);

    // 保存观察器实例，便于销毁
    el._observer = observer;
  },

  // 元素销毁时清理观察器（避免内存泄漏）
  unbind(el) {
    if (el._observer) {
      el._observer.unobserve(el);
    }
  }
});


router.beforeEach((to, from, next) => {
    /* set title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }

    if(verifyToken(to)){
        next();
    }else{
        console.log('验证不通过去认证');
    }

    //没有token不能进入功能住页面
    // if(!Tool.getToken()){
    //     next('/login');
    // }

    let allowBack = true    //    给个默认值true
    if (to.meta.allowBack !== undefined) {
        allowBack = to.meta.allowBack
    }
    if (!allowBack) {
        history.pushState(null, null, location.href)
    }
    store.commit('updateAppSetting', allowBack)
    let bread = menu.buildBread(to.fullPath);
    store.commit('updateBreadcrumb',bread);
});

router.afterEach((to, from) => {
    let page_title = getPageTitle(to.path);

    document.title = page_title;

    // window.gtag('config', 'G-GYZ3GY6CLF', {
    //     page_title: page_title,
    //     page_path: to.path,
    //     page_location: location.href,
    //     send_to: 'G-GYZ3GY6CLF'
    // })

    if (window.gtag && to.path !== from.path) {
      // 方式2：兼容原有config调用（可和event一起用）
      gtag('config', 'G-GYZ3GY6CLF', {
        page_title: page_title,
        page_path: to.path,
        page_location: window.location.href,
        send_to: 'G-GYZ3GY6CLF'
      });
    }

    setTimeout(function() {
        window.scrollTo(0, 0)
    },30)
})

function getPageTitle(path) {

  let page_title = path;

  if(path == "/") {
    page_title = "Kidney Heart Protect - Online Module - Home";
  }else if(path == "/section1" || path == "/section1/"){
    page_title = "Chapter 1: Introduction and Pre-activity Quiz";
  }else if(path == "/section1/1-1"){
    page_title = "Chapter 1-1: Pre-activity Quiz 1";
  }else if(path == "/section1/1-2"){
    page_title = "Chapter 1-2: Pre-activity Quiz 2";
  }else if(path == "/section1/1-3"){
    page_title = "Chapter 1-3: Pre-activity Quiz 3";
  }else if(path == "/section1/1-4"){
    page_title = "Chapter 1-4: Pre-activity Quiz 4";
  }else if(path == "/section1/1-5"){
    page_title = "Chapter 1-5: Pre-activity Quiz 5";
  }else if(path == "/section1/1-6"){
    page_title = "Chapter 1-6: Learning Objectives";
  }else if(path == "/section2" || path == "/section2/"){
    page_title = "Chapter 2: The role for kidney health monitoring in T2D";
  }else if(path == "/section2/2-1"){
    page_title = "Chapter 2-1: Kidney function monitoring and management";
  }else if(path == "/section2/2-2"){
    page_title = "Chapter 2-2: CV mortality risk is elevated in patients with T2D and CKD";
  }else if(path == "/section2/2-3"){
    page_title = "Chapter 2-3: Persistent albuminuria (UACR)";
  }else if(path == "/section2/2-4"){
    page_title = "Chapter 2-4: Regular measurement of UACR and eGFR";
  }else if(path == "/section2/2-5"){
    page_title = "Chapter 2-5: The role for regular measurement of UACR and eGFR";
  }else if(path == "/section3" || path == "/section3/"){
    page_title = "Chapter 3: Clinical evidence for nonsteroidal MRAs (finerenone) in reducing kidney progression and CV risks in CKD with T2D";
  }else if(path == "/section3/3-1"){
    page_title = "Chapter 3-1: How does the nonsteroidal MRA, finerenone, work?";
  }else if(path == "/section3/3-2"){
    page_title = "Chapter 3-2:  How does the nonsteroidal MRA, finerenone, work? (Part 2)";
  }else if(path == "/section3/3-3"){
    page_title = "Chapter 3-3: What patients are appropriate for nonsteroidal MRAs treatment with finerenone?";
  }else if(path == "/section3/3-4"){
    page_title = "Chapter 3-4: FIDELIO-DKD and FIGARO-DKD assessed prespecified kidney outcomes in patients across the spectrum of CKD severity";
  }else if(path == "/section3/3-5"){
    page_title = "Chapter 3-5: FIDELIO-DKD and FIGARO-DKD assessed prespecified kidney outcomes in patients across the spectrum of CKD severity (part 2)";
  }else if(path == "/section3/3-6"){
    page_title = "Chapter 3-6: FIGARO-DKD and FIDELIO-DKD investigated the effects of finerenone on kidney and CV outcomes in over 13,000 patients with CKD and T2D";
  }else if(path == "/section3/3-7"){
    page_title = "Chapter 3-7: Finerenone safety profile in Phase III trials";
  }else if(path == "/section3/3-8"){
    page_title = "Chapter 3-8: What do the Phase III studies say about finerenone and hyperkalaemia?";
  }else if(path == "/section3/3-9"){
    page_title = "Chapter 3-9: In FIDELITY, finerenone reduced UACR by 32% between baseline and month 4 versus placebo";
  }else if(path == "/section3/3-10"){
    page_title = "Chapter 3-10: Finerenone reduced the risk of the CV and kidney composite outcome";
  }else if(path == "/section3/3-11"){
    page_title = "Chapter 3-11: CONFIDENCE investigated the combination of finerenone and SGLT2i in persons with chronic kidney disease and type 2 diabetes";
  }else if(path == "/section3/3-12"){
    page_title = "Chapter 3-12: CONFIDENCE investigated the combination of finerenone and SGLT2i in persons with chronic kidney disease and type 2 diabetes (part 2)";
  }else if(path == "/section3/3-13"){
    page_title = "Chapter 3-13: CONFIDENCE investigated the combination of finerenone and SGLT2i in persons with chronic kidney disease and type 2 diabetes (part 3)";
  }else if(path == "/section4" || path == "/section4/"){
    page_title = "Chapter 4: Initiating nonsteroidal MRAs (finerenone) in clinical practice as part of a comprehensive approach to CKD associated with T2D";
  }else if(path == "/section4/4-1"){
    page_title = "Chapter 4-1: People with diabetes and chronic kidney disease (CKD)";
  }else if(path == "/section4/4-2"){
    page_title = "Chapter 4-2: International and local guidelines";
  }else if(path == "/section4/4-3"){
    page_title = "Chapter 4-3: Recent clinical guidelines for the management of CKD in patients with T2D";
  }else if(path == "/section4/4-4"){
    page_title = "Chapter 4-4: ESC 2023 guideline recommendations for treatment of patients with T2D and CKD1";
  }else if(path == "/section4/4-5"){
    page_title = "Chapter 4-5: Which of your patients would be eligible for nonsteroidal MRAs (finerenone)?";
  }else if(path == "/section4/4-6"){
    page_title = "Chapter 4-6: Impact on eGFR after initiation of finerenone";
  }else if(path == "/section4/4-7"){
    page_title = "Chapter 4-7: Prescribing considerations for finerenone";
  }else if(path == "/section4/4-8"){
    page_title = "Chapter 4-8: Initiation, dosing and titration";
  }else if(path == "/section4/4-9"){
    page_title = "Chapter 4-9: Closing thoughts";
  }else if(path == "/section5" || path == "/section5/"){
    page_title = "Chapter 5: Post-activity Quiz";
  }else if(path == "/section5/5-1"){
    page_title = "Chapter 5-1: Post-activity Question 1";
  }else if(path == "/section5/5-2"){
    page_title = "Chapter 5-2: Post-activity Question 2";
  }else if(path == "/section5/5-3"){
    page_title = "Chapter 5-3: Post-activity Question 3";
  }else if(path == "/section5/5-4"){
    page_title = "Chapter 5-3: Post-activity Question 4";
  }else if(path == "/section5/5-5"){
    page_title = "Chapter 5-3: Post-activity Question 5";
  }else if(path == "/section5/5-6"){
    page_title = "Module completed";
  }

  return page_title;
}

function verifyToken(to) {
    if(process.env.VUE_APP_MODE === 'dev'){
        return true;
    }else{
        if (to.meta.authModel) {
            let token = Tool.getToken();
            if (token == null) {
                return false;
            }
        }
        return true;
    }
}


export default new Vue({
    router,
    store,
    components: {App},
    template: "<App/>"
}).$mount("#app");
